import React from 'react'
import PropTypes from 'prop-types'

const debug = false
// const debug = "UI5CalendarMonthHeader"

export default class UI5CalendarMonthHeader extends React.Component {
    static propTypes = {
        onBack      : PropTypes.func,
        onCurrent   : PropTypes.func,
    }

    render() {
        return (
            <div className="navigation-header fl-sb month-selection-header">
                <div className="ui5-control-button ui5-ico-back blue s-26 fs-18" onClick={this.props.onBack}/>
                <div className="title ui5-title-small">Choose month</div>
                <div className="ui5-control-button i5-date-star s-26 fs-14" onClick={this.props.onCurrent}/>
            </div>
        )
    }
}